import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from 'evolve-ui';
import {
  formatQueryForJsonApi,
  IEntity,
  JsonApiQueryParameters,
  transformResponseFromJsonApi,
} from '@evolve/common-ui';

export type TDraftDataCustomer = {
  code: string;
  name: string;
  address: string;
  location: string;
  postal_code: string;
  fiscal_number: string;
  social_security_number: string;
};

export type TDraftDataCostCenter = {
  code: string;
  description: string;
  address: string;
  location: string;
  postal_code: string;
};

export type TDraftDataObject = {
  customer: TDraftDataCustomer;
  costCenter: TDraftDataCostCenter;
};

export interface IContract extends IEntity {
  number: string;
  reference: string;
  startDate: string;
  endDate: string;
  created: string;
  createdUser: { name: string; acronym: string };
  manager: { name: string; acronym: string };
  type: string;
  contractTemplate: { name: string; content: string };
  insurance: { id: string; description: string };
  customerContract: { id: string; reference: string };
  requestEmployee: { reference: string };
  requestEmployeeCategory: {
    professionalCategory: string;
    mealSubsidyType: { name: string };
  };
  draftData: TDraftDataObject;
  contractStatusId: number;
}

export const contractsApi = createApi({
  reducerPath: 'contracts',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.GATSBY_CONTRACTS_API_URL}`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['Contracts'],
  endpoints: (builder) => ({
    getContracts: builder.query<
      { values: IContract[]; total: number; ids: string[] },
      JsonApiQueryParameters
    >({
      providesTags: ['Contracts'],
      query: (params) => formatQueryForJsonApi(params, ''),
      transformResponse: transformResponseFromJsonApi<IContract>,
    }),
  }),
});

export const { useGetContractsQuery } = contractsApi;
